export default __webpack_public_path__ + "static/media/part_2_bt_2.639ea78f.png";